import React from 'react';
import Checkoutadvertisement from './Checkoutadvertisement';
import './Advertisement.css'

function Advertisement() {
  return <div className='advertisement'>
      <h4>Some More Sponsored Product For You</h4>
      <div>
      <Checkoutadvertisement 
          id={111}
          title="CHAI POINT Instant Tea | Incredibly Authentic | Elaichi Flavor | 10 Sachets | Elaichi Tea | Instant Tea Premix Tea| Assam Tea| Elaichi"
          price={2.4}
          rating={4}
          image="https://images-eu.ssl-images-amazon.com/images/I/71PjTbZauCL._AC_UL100_SR100,100_.jpg"
      />
      </div>
      
      <div>
      <Checkoutadvertisement 
          id={112}
          title="Dixcy Scott Men’s Trunk Snug Fit Solid Innerwear (Pack of 3)"
          price={2.4}
          rating={4}
          image="https://images-eu.ssl-images-amazon.com/images/I/817nB3mLa7L._AC_UL200_SR200,200_.jpg"
      />
      {/* <img src="https://images-eu.ssl-images-amazon.com/images/I/81iptU9Mt3L._AC_UL100_SR100,100_.jpg"></img> */}
      </div>
      
      <div>
         <Checkoutadvertisement
         id={113}
         title="Lenovo 130 USB Optical Compact Mouse, Black"
         price={7.3}
         rating={5}
         image="https://images-eu.ssl-images-amazon.com/images/I/21N0SU36xXL._AC_UL100_SR100,100_.jpg"
          />
      </div>

      <div>
        <Checkoutadvertisement
            id={114} 
            title="Dynotrek Azon Black Up to 15.6 Inch Laptop Case 14.6 Notebook Chromebook Sleeve for Men Women 13.6 Briefcase Messenger Hand Bag (41 Black)"
            price={10}
            rating={5}
            image="https://images-eu.ssl-images-amazon.com/images/I/81iptU9Mt3L._AC_UL100_SR100,100_.jpg"
        />
      </div>
  </div>;
}

export default Advertisement;
